export const getFileByUrl = async url => {
  const blob = await (await fetch(`${url}?cacheblock=true`)).blob();
  const filename = url.split('/').pop();
  return new File([blob], filename);
};
